import { Component, OnInit } from '@angular/core';
import { Constant } from '../constant';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.css'],
    providers: [Title],
    standalone: false
})
export class TermsComponent implements OnInit {
  public readonly Constant = Constant;
  constructor(private title: Title) {
    this.title.setTitle(Constant.pageTitleTerms + Constant.pageTitleCommon);
  }

  ngOnInit() {}
}
